<div class="dashboard-container">
  @if (loading) {
    <div class="stats-grid">
      <div class="skeleton-box"></div>
      <div class="skeleton-box"></div>
      <div class="skeleton-box"></div>
      <div class="skeleton-box"></div>
      <div class="skeleton-box"></div>
    </div>
  } @else {
    <div class="stats-grid">
      <div class="stat-card email-card">
        <svg
          class="stat-icon"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6ZM20 6L12 11L4 6H20ZM20 18H4V8L12 13L20 8V18Z"
            fill="currentColor"
          />
        </svg>
        <div class="stat-content">
          <h3>Emails Sent</h3>
          <div class="stat-value">
            {{ cdfiOutreachStats.total_emails_sent }}
          </div>
        </div>
      </div>

      <div class="stat-card complete-card">
        <svg
          class="stat-icon"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM16.59 7.58L10 14.17L7.41 11.59L6 13L10 17L18 9L16.59 7.58Z"
            fill="currentColor"
          />
        </svg>
        <div class="stat-content">
          <h3>Completed Responses</h3>
          <div class="stat-value">
            {{ cdfiOutreachStats.total_submissions }}
          </div>
        </div>
      </div>

      <div class="stat-card pending-card">
        <svg
          class="stat-icon"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12.5 7H11V13L16.2 16.2L17 14.9L12.5 12.2V7Z"
            fill="currentColor"
          />
        </svg>
        <div class="stat-content">
          <h3>Awaiting Responses</h3>
          <div class="stat-value">
            {{
              cdfiOutreachStats.total_emails_sent -
                cdfiOutreachStats.total_submissions -
                cdfiOutreachStats.expired_forms
            }}
          </div>
        </div>
      </div>

      <div class="stat-card expired-card">
        <svg
          class="stat-icon"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13 3C8.03 3 4 7.03 4 12H1L4.89 15.89L4.96 16.03L9 12H6C6 8.13 9.13 5 13 5C16.87 5 20 8.13 20 12C20 15.87 16.87 19 13 19C11.07 19 9.32 18.21 8.06 16.94L6.64 18.36C8.27 19.99 10.51 21 13 21C17.97 21 22 16.97 22 12C22 7.03 17.97 3 13 3ZM12 8V13L16.25 15.52L17.02 14.24L13.5 12.15V8H12Z"
            fill="currentColor"
          />
        </svg>
        <div class="stat-content">
          <h3>Expired Forms</h3>
          <div class="stat-value">
            {{ cdfiOutreachStats.expired_forms }}
          </div>
        </div>
      </div>

      <div class="stat-card rate-card">
        <svg
          class="stat-icon"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.5 18.5L9.5 12.5L13.5 16.5L22 6.92L20.59 5.5L13.5 13.5L9.5 9.5L2 17L3.5 18.5Z"
            fill="currentColor"
          />
        </svg>
        <div class="stat-content">
          <h3>Response Rate</h3>
          <div class="stat-value">
            {{ cdfiOutreachStats.submission_percentage }}%
          </div>
        </div>
      </div>
    </div>
  }
</div>
